module.exports = __webpack_public_path__ + "static/KarinaResume-119cf1d215d66c257303d211f5edb184.pdf";